import { useEffect, useMemo, useState } from 'react';
import TheButton from '@/components/TheButton/TheButton';
import classNames from './PopUpOpenWrittingAIReview.module.scss';
import PopUpOpenWrittingError from './components/PopUpOpenError/PopUpOpenWrittingError';
import PopUpOpenWrittingSuccess from './components/PopUpOpenSuccess/PopUpOpenWrittingSuccess';
import classes from 'classnames';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/store';
import { gameSelector } from '@/store/reducers/game';
import lamp from '@/assets/svg/lamp.svg';

//FIXME: Need to change any for needed type
const PopUpOpenWrittingAIReview = ({ emitOnNextQuestion, emitOnRetry }: any) => {
  const { t } = useTranslation();
  const {
    currentQuestionIndex,
    quizQuestionResultData,
    gameQuestions,
    isOpenWritingAnswerInEnglish,
  } = useAppSelector(gameSelector);
  const [isAttempts, setIsAttempts] = useState(false);

  const questionId = useMemo(
    () => gameQuestions?.[currentQuestionIndex]?.questionId,
    [gameQuestions, currentQuestionIndex]
  );
  const result = useMemo(
    () => quizQuestionResultData?.[currentQuestionIndex]?.openWritingResult,
    [quizQuestionResultData, currentQuestionIndex]
  );
  const hasScore = quizQuestionResultData?.[currentQuestionIndex]?.hasScore;
  const scoreResponse = (result?.scoreResponse || result) as any;

  const isVulgar = scoreResponse?.containsVulgarLanguage;
  const isGibberish = scoreResponse?.containsGibberish;

  const showIsNotEnglishError =
    gameQuestions?.[currentQuestionIndex]?.newData?.data?.metadata?.isResponseInEnglish &&
    !isOpenWritingAnswerInEnglish;

  useEffect(() => {
    if (hasScore === false && !isVulgar && !isGibberish && !showIsNotEnglishError) {
      emitOnNextQuestion();
      return;
    }

    if (!questionId || !result) return;

    const storageKey = 'openWritingAttempts';
    const attemptsData = JSON.parse(sessionStorage.getItem(storageKey) || '{}');

    let currentAttempts = attemptsData[questionId] || 0;

    if (isVulgar || isGibberish || showIsNotEnglishError) {
      currentAttempts++;
    } else {
      currentAttempts = 0;
    }

    attemptsData[questionId] = currentAttempts;
    sessionStorage.setItem(storageKey, JSON.stringify(attemptsData));

    if (currentAttempts >= 3) {
      setIsAttempts(true);
      sessionStorage.setItem('openWritingAttempts', 'true');
      emitOnNextQuestion();
    }
  }, [
    hasScore,
    result,
    emitOnNextQuestion,
    isVulgar,
    isGibberish,
    showIsNotEnglishError,
    questionId,
  ]);

  if (hasScore === false && !isVulgar && !isGibberish && !showIsNotEnglishError) {
    return null;
  }

  if (scoreResponse?.noGrading && !isVulgar && !isGibberish && !showIsNotEnglishError) {
    return (
      <div className={classes('container', classNames.popUpOpenWritting)}>
        <PopUpOpenWrittingSuccess />
        <div className={classNames.buttons} style={{ marginTop: '20px' }}>
          <TheButton text={t('next')} emitOnClick={emitOnNextQuestion} />
        </div>
      </div>
    );
  }

  const content = scoreResponse?.aIGradingReview;

  return (
    <div className={classes('container', classNames.popUpOpenWritting)}>
      {!isAttempts && (isVulgar || isGibberish || showIsNotEnglishError) ? (
        <PopUpOpenWrittingError
          isVulgar={isVulgar}
          isGibberish={isGibberish}
          isNotEnglish={showIsNotEnglishError}
        />
      ) : (
        <>
          <div className={classNames.title}>
            <span>{t('thankYou')}</span>
          </div>
          <div className={classNames.details}>
            <div className={classNames.detailsTitle}>
              <SVG src={lamp} />
              <span>{t('review')}</span>
            </div>

            <p>{content}</p>
          </div>
        </>
      )}

      <div className={classNames.buttons}>
        <TheButton
          className={'flex-1'}
          text={t(isVulgar || isGibberish || showIsNotEnglishError ? 'tryAgain' : 'next')}
          emitOnClick={() =>
            !isAttempts && (isVulgar || isGibberish || showIsNotEnglishError)
              ? emitOnRetry?.()
              : emitOnNextQuestion?.()
          }
        />
      </div>
    </div>
  );
};

export default PopUpOpenWrittingAIReview;
